<div class="clug-reports-page">

  <div class="page-head">
    <div>
      <h1>Reports</h1>
      <p class="lede">Generate contractor payroll reports, then export to your accounting tool.</p>
    </div>
  </div>

  <div class="page-tabs">
    <a class="page-tab active" routerLink="/reports/payroll" routerLinkActive="active">
      <i class="bi bi-cash-stack"></i>Payroll
    </a>
    <a class="page-tab" routerLink="/reports/pay-bill" routerLinkActive="active">
      <i class="bi bi-receipt"></i>Billing
    </a>
  </div>

  <form [formGroup]="payBillSearchForm" (ngSubmit)="onSubmit()">
    <div class="filter-card">
      <div class="filter-card-row">

        <div class="filter-field">
          <label>Report type</label>
          <div class="seg-lg">
            <button type="button" [class.on]="payBillSearchForm.value.report_type === 'general_report'"
              (click)="setReportType('general_report')">
              <i class="bi bi-list-ul"></i>General
            </button>
            <button type="button" [class.on]="payBillSearchForm.value.report_type === 'detailed_report'"
              (click)="setReportType('detailed_report')">
              <i class="bi bi-table"></i>Detailed
            </button>
          </div>
        </div>

        <div class="filter-field">
          <label>Date range</label>
          <div class="date-combo">
            <div class="range">
              <i class="bi bi-calendar4"></i>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate formControlName="start_date" placeholder="Start" />
                <input matEndDate formControlName="end_date" placeholder="End"
                  (dateChange)="DatepcikerEndDateChanged($event)" />
              </mat-date-range-input>
              <mat-date-range-picker touchUi="true" #picker></mat-date-range-picker>
            </div>
            <div class="preset">
              <i class="bi bi-clock-history"></i>
              <span class="preset-text">{{ selectedFilterOption }}</span>
              <i class="bi bi-chevron-down"></i>
              <mat-select panelClass="matRole timesheetDateFilterPanel" (selectionChange)="onFilterChange(picker)"
                [(ngModel)]="selectedFilterOption" [ngModelOptions]="{standalone: true}">
                <mat-option>Recently Submitted</mat-option>
                <mat-option [value]="option.label" *ngFor="let option of filterOptions">{{ option.label }}</mat-option>
                <mat-option value="datePicker" (click)="onFilterChange(picker)">Date picker</mat-option>
                <mat-option [value]="custom_datepicker_text" class="d-none">{{ custom_datepicker_text }}</mat-option>
              </mat-select>
            </div>
          </div>
        </div>

        <div class="filter-field">
          <label class="spacer">.</label>
          <button type="submit" class="btn btn-primary btn-tall" [disabled]="!payBillSearchForm.valid || loading">
            <i class="bi bi-play-fill"></i>Generate
          </button>
        </div>

      </div>
    </div>
  </form>

  <div class="kpi-strip" *ngIf="payBillReportData && payBillReportData.length">
    <div class="kpi-mini">
      <span class="ico blue"><i class="bi bi-people"></i></span>
      <div class="text">
        <span class="label">Contractors</span>
        <span class="value">{{ totalContractors }}</span>
      </div>
    </div>
    <div class="kpi-mini">
      <span class="ico green"><i class="bi bi-clock-history"></i></span>
      <div class="text">
        <span class="label">{{ trackHours == 2 ? 'Total days' : 'Total hours' }}</span>
        <span class="value">
          {{ totalHours | number: '1.1-1' }}<span class="unit">{{ trackHours == 2 ? 'd' : 'hrs' }}</span>
        </span>
      </div>
    </div>
    <!-- <div class="kpi-mini">
      <span class="ico amber"><i class="bi bi-stopwatch"></i></span>
      <div class="text">
        <span class="label">Overtime</span>
        <span class="value">
          {{ totalOt | number: '1.1-1' }}<span class="unit">hrs</span>
        </span>
      </div>
    </div> -->
    <div class="kpi-mini">
      <span class="ico coral"><i class="bi bi-cash-coin"></i></span>
      <div class="text">
        <span class="label">Total pay</span>
        <span class="value">
          <span class="unit" style="margin-left:0;margin-right:2px;">{{ currencyFormat || '£' }}</span>{{ totalMoney |
          number: '1.2-2' }}
        </span>
      </div>
    </div>
  </div>

  <div class="results-card">
    <div class="reports-loader" *ngIf="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div class="report-card-head" *ngIf="payBillReportData && payBillReportData.length">
      <div class="lhs">
        <h5>Payroll report data</h5>
        <span class="meta-pill">
          <i class="bi" [ngClass]="reportType === 'detailed_report' ? 'bi-table' : 'bi-list-ul'"></i>
          {{ reportType === 'detailed_report' ? 'Detailed' : 'General' }}
        </span>
        <span class="meta-pill" *ngIf="payBillSearchForm.value.start_date && payBillSearchForm.value.end_date">
          <i class="bi bi-calendar3"></i>
          {{ payBillSearchForm.value.start_date | date: 'd MMM' }} –
          {{ payBillSearchForm.value.end_date | date: 'd MMM y' }}
        </span>
      </div>
      <div class="rhs">
        <input formControlName="candidate_uuid" style="display:none;" />
        <app-select-search class="report-search" (onChange)="onSearchChange($event)" [endpoint]="API_CONSTANT.USERS"
          [control]="payBillSearchForm.controls.candidate_uuid" controlName="candidate_uuid" titleKey="name">
        </app-select-search>

        <div class="export-wrap">
          <button type="button" class="btn btn-primary" (click)="toggleExport($event)">
            <i class="bi bi-download"></i>Export
            <i class="bi bi-chevron-down" style="font-size:11px;margin-left:2px;"></i>
          </button>
          <div class="export-pop" [class.open]="exportOpen" (click)="$event.stopPropagation()">
            <div class="head">
              <span class="title">Export payroll report</span>
              <span class="sub">{{ totalContractors }} contractors · {{ payBillSearchForm.value.start_date | date: 'd
                MMM' }} – {{ payBillSearchForm.value.end_date | date: 'd MMM y' }}</span>
            </div>
            <div class="section-title">Generic formats</div>
            <div class="export-grid">
              <button type="button" class="export-tile wide" (click)="onExport('excel')">
                <span class="logo" style="background:#107C41;">XL</span>
                <span class="name">Excel</span>
                <span class="meta">.xlsx — universal spreadsheet</span>
              </button>
            </div>
            <div class="section-title">Accounting integrations</div>
            <div class="export-grid">
              <button type="button" class="export-tile" (click)="onExport('sage')">
                <span class="recent-dot" title="Last used"></span>
                <span class="logo" style="background:#0DAA56;">SA</span>
                <span class="name">Sage</span>
                <span class="meta">.xlsx</span>
              </button>
              <button type="button" class="export-tile" (click)="onExport('xero')">
                <span class="logo" style="background:#13B5EA;">XE</span>
                <span class="name">Xero</span>
                <span class="meta">.xlsx</span>
              </button>
              <button type="button" class="export-tile" (click)="onExport('quick_book')">
                <span class="logo" style="background:#2CA01C;">QB</span>
                <span class="name">QuickBooks</span>
                <span class="meta">.xlsx</span>
              </button>
              <button type="button" class="export-tile" (click)="onExport('gusto')">
                <span class="logo" style="background:#F45D48;">GU</span>
                <span class="name">Gusto</span>
                <span class="meta">.xlsx</span>
              </button>
              <button type="button" class="export-tile" (click)="onExport('ukg')">
                <span class="logo" style="background:#005EB8;">UK</span>
                <span class="name">UKG</span>
                <span class="meta">.xlsx</span>
              </button>
              <button type="button" class="export-tile" (click)="onExport('pay_chex')">
                <span class="logo" style="background:#0067B1;">PA</span>
                <span class="name">Paychex</span>
                <span class="meta">.xlsx</span>
              </button>
            </div>


          </div>
        </div>
      </div>
    </div>

    <div class="scroll-x" *ngIf="payBillReportData && payBillReportData.length; else emptyPane">

      <!-- General report -->
      <table class="table" *ngIf="reportType === 'general_report'">
        <thead>
          <tr>
            <th>Contractor</th>
            <th>Company</th>
            <th>Job</th>
            <th class="num" *ngIf="trackHours != 2">Total hrs</th>
            <th class="num" *ngIf="trackHours != 2">Regular</th>
            <th class="num" *ngIf="trackHours != 2">OT</th>
            <th class="num" *ngIf="trackHours != 2">Double OT</th>
            <th class="num" *ngIf="trackHours == 2">Total days</th>
            <th class="num">{{ trackHours == 2 ? 'Rate (daily)' : 'Rate (hourly)' }}</th>
            <th class="num">Pay</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payBill of payBillReportData">
            <td>
              <div class="contractor">
                <div class="avatar">{{ initialsOf(payBill.candidate) }}</div>
                <div>
                  <div class="name">{{ payBill.candidate }}</div>
                  <div class="sub-id">{{ payBill.contractor_id }}</div>
                </div>
              </div>
            </td>
            <td>
              <div class="cell-with-icon">
                <span class="cell-icon"><i class="bi bi-building"></i></span>
                <span class="text">{{ payBill.client }}</span>
              </div>
            </td>
            <td>
              <div class="cell-with-icon">
                <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
                <span class="text">{{ payBill.job }}</span>
              </div>
            </td>
            <td class="num" *ngIf="trackHours != 2">{{ payBill.total_hours }}</td>
            <td class="num" *ngIf="trackHours != 2">{{ payBill.regular_hours }}</td>
            <td class="num" *ngIf="trackHours != 2">
              <span *ngIf="payBill.ot_hours > 0; else otZero" class="ot-hot">{{ payBill.ot_hours }}</span>
              <ng-template #otZero><span class="zero-dash">—</span></ng-template>
            </td>
            <td class="num" *ngIf="trackHours != 2">
              <span *ngIf="payBill.double_ot_hours > 0; else dotZero" class="ot-hot">{{ payBill.double_ot_hours
                }}</span>
              <ng-template #dotZero><span class="zero-dash">—</span></ng-template>
            </td>
            <td class="num" *ngIf="trackHours == 2">{{ payBill.total_days }}</td>
            <td class="num">{{ currencyFormat }} {{ payBill.pay_rate_hourly }}</td>
            <td class="num">{{ currencyFormat }} {{ payBill.total_pay }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="label">Total</td>
            <td class="num" *ngIf="trackHours != 2">{{ totalHours | number: '1.1-1' }}</td>
            <td class="num" *ngIf="trackHours != 2">{{ totalRegular | number: '1.1-1' }}</td>
            <td class="num" *ngIf="trackHours != 2">{{ totalOt | number: '1.1-1' }}</td>
            <td class="num" *ngIf="trackHours != 2">{{ totalDoubleOt | number: '1.1-1' }}</td>
            <td class="num" *ngIf="trackHours == 2">{{ totalHours | number: '1.1-1' }}</td>
            <td class="num">—</td>
            <td class="num">{{ currencyFormat }} {{ totalMoney | number: '1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>

      <!-- Detailed report -->
      <table class="table" *ngIf="reportType === 'detailed_report'">
        <thead>
          <tr>
            <th>Contractor</th>
            <th>Company</th>
            <th>Job</th>
            <th>Status</th>
            <th class="num" *ngFor="let reportDate of payBillReportDates">
              <div class="day-h">
                <span class="d">{{ reportDate }}</span>
              </div>
            </th>
            <th class="num">{{ trackHours == 2 ? 'Total days' : 'Total hrs' }}</th>
            <th class="num">Pay</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payBill of payBillReportData">
            <td>
              <div class="contractor">
                <div class="avatar">{{ initialsOf(payBill.candidate) }}</div>
                <div>
                  <div class="name">{{ payBill.candidate }}</div>
                  <div class="sub-id">{{ payBill.contractor_id }}</div>
                </div>
              </div>
            </td>
            <td>
              <div class="cell-with-icon">
                <span class="cell-icon"><i class="bi bi-building"></i></span>
                <span class="text">{{ payBill.client }}</span>
              </div>
            </td>
            <td>
              <div class="cell-with-icon">
                <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
                <span class="text">{{ payBill.job }}</span>
              </div>
            </td>
            <td>
              <span class="pill-mini" [ngClass]="statusClass(payBill.timesheet_status)">
                <i class="bi" [ngClass]="statusIcon(payBill.timesheet_status)"></i>
                {{ payBill.timesheet_status }}
              </span>
            </td>
            <td class="num" *ngFor="let reportInfo of payBill.report_info">
              <ng-container *ngIf="trackHours != 2">
                <span *ngIf="reportInfo.hours > 0; else dHrZero">{{ reportInfo.hours }}</span>
                <ng-template #dHrZero><span class="zero-dash">—</span></ng-template>
              </ng-container>
              <ng-container *ngIf="trackHours == 2">
                <span *ngIf="reportInfo.total_days > 0; else dDayZero">{{ reportInfo.total_days }}</span>
                <ng-template #dDayZero><span class="zero-dash">—</span></ng-template>
              </ng-container>
            </td>
            <td class="num" *ngIf="trackHours != 2">{{ payBill.total_hours }}</td>
            <td class="num" *ngIf="trackHours == 2">{{ payBill.total_days }}</td>
            <td class="num">{{ currencyFormat }} {{ payBill.total_pay }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyPane>
      <div class="empty-pane">
        <div class="ico"><i class="bi bi-bar-chart-line"></i></div>
        <h4>No report generated yet</h4>
        <p>Pick a report type and date range above, then hit Generate.</p>
      </div>
    </ng-template>
  </div>
</div>